import type { SelectOption } from '@/shared/ui/selectTypes';

export type MetricType = 'currency' | 'count' | 'percent';

export interface Metric {
  name: string;
  field: string;
  type: MetricType;
}

/** Dashboard rows (legacy `newDashboardItemsConfig`). */
export const DASHBOARD_METRICS: Metric[] = [
  { name: 'Регистрации', field: 'registrations', type: 'count' },
  { name: 'Добавлено авто в гараж', field: 'garage_added', type: 'count' },
  { name: 'CV в гараж из регистрации', field: 'cv_garage_to_reg_pct', type: 'percent' },
  { name: 'Заявки', field: 'requests', type: 'count' },
  { name: 'CV из регистр. в заявку', field: 'cv_request_to_reg_pct', type: 'percent' },
  { name: 'Дубли заявок', field: 'request_duplicates', type: 'count' },
  { name: 'Отмененные заявки', field: 'request_canceled', type: 'count' },
  { name: 'CV в работу из заявки', field: 'cv_work_to_request_pct', type: 'percent' },
  { name: 'CV в ремонт из заявки', field: 'cv_repair_to_request_pct', type: 'percent' },
  { name: 'Ремонты', field: 'repairs_finished', type: 'count' },
  { name: 'Новые СТО', field: 'new_services', type: 'count' },
  { name: 'Взяли в работу', field: 'bid_was_in_work_count', type: 'count' },
  { name: 'Отзывы 5/4', field: 'review_with_5_4_stars_count', type: 'count' },
  { name: 'Отзывы 3/2', field: 'review_with_3_2_stars_count', type: 'count' },
  { name: 'Отзывы ШТ', field: 'review_count', type: 'count' },
  { name: 'CR отзыв из ремонта', field: 'reviewed_bids_percent', type: 'percent' },
];

export const TOTAL_INCOME_FIELD = 'commissions_sum';

/** The dashboard is only available for Russia (legacy `RUSSIA_ID`). */
export const DASHBOARD_COUNTRY_ID = 1;
export const CURRENCY_SYMBOL = '\u00A0₽';

export const CITY_OPTIONS: SelectOption[] = [
  { value: '1', label: 'Москва' },
  { value: '173', label: 'Санкт-Петербург' },
  { value: '609', label: 'Воронеж' },
  { value: '1775', label: 'Самара' },
  { value: '1921', label: 'Екатеринбург' },
  { value: '2090', label: 'Казань' },
  { value: '1042', label: 'Краснодар' },
  { value: '1116', label: 'Красноярск' },
  { value: '1406', label: 'Новосибирск' },
  { value: '2419', label: 'Челябинск' },
  { value: '1705', label: 'Ростов-на-Дону' },
  { value: '1060', label: 'Сочи' },
  { value: '1342', label: 'Нижний Новгород' },
];

export const SEGMENT_OPTIONS: SelectOption[] = [
  { value: 'all', label: 'Общее' },
  { value: 'b2c', label: 'B2C' },
  { value: 'b2b', label: 'B2B' },
];

export const BID_SOURCE_OPTIONS: SelectOption[] = [
  { value: 'all', label: 'Все' },
  { value: 'ai', label: 'ai' },
  { value: 'manual', label: 'manual' },
];

/** Countries available in the stat filters (legacy `myCountries`). */
export const STAT_COUNTRY_OPTIONS: SelectOption[] = [
  { value: '1', label: 'Россия' },
  { value: '22', label: 'Беларусь' },
  { value: '82', label: 'Казахстан' },
];

export const MONTH_OPTIONS: SelectOption[] = [
  'Январь',
  'Февраль',
  'Март',
  'Апрель',
  'Май',
  'Июнь',
  'Июль',
  'Август',
  'Сентябрь',
  'Октябрь',
  'Ноябрь',
  'Декабрь',
].map((label, index) => ({ value: String(index), label }));

export const FRANCHISE_OPTIONS: SelectOption[] = [
  { value: '1', label: 'Только франчайзи' },
  { value: '0', label: 'Кроме франчайзи' },
];
